// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Currency } from '@/currency/api/types';
import { formatCurrencyValue } from '@/currency/utilities/format';
import { Typography } from '@mui/material';

interface Props {
  /**
   * The total contract value of a project as a currency pair.
   */
  value: Currency | null;
}

/**
 * A label component that displays the total contract value of a project as a
 * formatted currency string in the value's own currency.
 */
export function ProjectTotalContractValueLabel(props: Props) {
  const color = props.value === null ? 'text.secondary' : 'text.primary';

  return (
    <Typography variant="body2" color={color}>
      {formatCurrencyValue(props.value, { placeholder: 'Not set' })}
    </Typography>
  );
}
